class ReactFilterCombo extends React.Component{

    constructor(props) {
        super(props);
        this._initialLoad = true;
        this._doInitialReload = false;
        ModulesMixinsOutsideClick._composite(this);

        var selectedValues = {};
        if (props.value) {
            selectedValues = this.processValue(props.value)
        }


        var minChars = parseInt(this.props.minChars);
        var hasMinChars = false;
        if (minChars && minChars > 0) {
            hasMinChars = true;
        }

        this.state = {
            isActive: false,
            isExpanded: false,
            idField: props.idField,
            displayField: props.displayField,
            records: props.records,
            selectedValues: selectedValues,
            query: '',
            value: props.value,
            paginated: props.paginated,
            wide: props.wide,
            showSearch: props.showSearch,
            hasMinChars: hasMinChars
        };
    }

    /**
     * TODO: Fix cdm not being called (maybe this is related to call the class using eval in Grid.jsx:1482)
     */
    componentDidMount(){
        if(!this.afterRenderFired) {
            this.afterRender();
        }
    }

    afterRender(){
        if(!this.afterRenderFired) {
            this.load();
            this.afterRenderFired = true;
        }
    }

    processValue(value){
        var selectedValues = {};
        var values = value instanceof Array ? value : value.split(',');
        values.forEach(function(v){
            selectedValues[v] = true;
        });
        
        return selectedValues;
    }

    /**
     * Called by the grid, should return the data to be sent to the ajax.
     * @returns Object
     */
    getValues() {
        var val = [];
        var isActive = false;
        for(var i in this.state.selectedValues) {
            if (this.state.selectedValues.hasOwnProperty(i) && this.state.selectedValues[i]) {
                if(i && i !== "any"){
                    isActive = true;
                }
                val.push(i);
            }
        }

        this.setState({isActive: isActive});

        return val.join(',');
    }
    /**
     * Called by the grid, should reset it's values to the defaults.
     */
    clearValues() {
        this.setState({
            isActive: false,
            selectedValues: {}
        });
    }
    /**
     * Called by the grid, should set valuies
     * @returns Object
     */
    setValues(values) {
        if(values.value){
            this._initialLoad = true;
            this.setState({
                isActive:true,
                value: values.value,
                selectedValues:this.processValue(values.value),
                query: '',
                page: undefined
            },function(){
                this.load();
            }.bind(this))
        }else{
            this.clearValues();
        }
    }

    clearFilter() {
        this.clearValues();
        if(this.props.loadGrid) {
            setTimeout( function(){
                this.props.loadGrid();
            }.bind(this), 50);
        }
    }

    togglePopup() {
        this.setState({
            isExpanded: !this.state.isExpanded
        });
    }

    /**
     * Called by "OutsideClick" Mixin to handle outside click
     */
    outsideClickHandle(e) {
        this.setState({
            isExpanded: false
        });
    }

    handleFilterButtons(event) {
        this.setState({
            isExpanded: false
        });

        if(event.target.dataset.button == "apply"){
            this.props.applyFilters();
        }
        if(event.target.dataset.button == "clear"){
            this.props.clearFilters();
        }
    }

    onSelectionChange(event) {
        var selectedValues = this.state.selectedValues;
        if(this.props.singleSelect){
            selectedValues = {};
        }
        if(event.target.checked){
            selectedValues[$(event.target).data('value')] = $(event.target).data('label');
        }else{
            delete selectedValues[$(event.target).data('value')];
        }
        this.setState({selectedValues: selectedValues})
    }

    onSearch(event) {
        this.setState({
            page:1,
            query: event.target.value,
            selectedValues: this.state.selectedValues
        });

        clearTimeout(this.timeout);
        this.timeout = setTimeout(function(){
            this.load();
        }.bind(this), 350);

    }

    onPrevious() {
        var page = this.state.page?this.state.page:1;
        page--;
        if(page<1){
            page = 1;
        }
        this.onPage(page);
    }

    onNext() {
        var page = this.state.page?this.state.page:1;
        page++;
        this.onPage(page);
    }

    onPage(page) {
        this.setState({
            page: page,
            selectedValues: this.state.selectedValues
        });

        clearTimeout(this.timeout);
        this.timeout = setTimeout(function(){
            this.load();
        }.bind(this), 350);
    }

    onSearchKeyUp(event) {
        this.updateSearchField(event.target.value, event.target.parentElement);
    }

    clearSearch(e) {
        this.updateSearchField(null, e.target.parentElement);

        this.onSearch(e);
    }

    updateSearchField(value, parent) {
        // todo: do this with react
        if(value && value.length > 0){
            $(parent).addClass('with-value');
        } else {
            $(parent).removeClass('with-value');

            $(this.refs.search_field).val("");
        }
    }

    deepFind(obj, path) {
        var paths = path.split('.')
            , current = obj
            , i;
    
        for (i = 0; i < paths.length; ++i) {
            if (current[paths[i]] == undefined) {
                return undefined;
            } else {
                current = current[paths[i]];
            }
        }
        return current;
    }

    load() {

        if(!this.props.url){
            return;
        }
        
        var urlParams = this.props.urlParams;
        var query = this.state.query;
        urlParams.query = query;
        urlParams.page = this.state.page;
        var initialLimit = urlParams.limit;
        
        if(this._initialLoad){

            this._initialLoad = false;

            if(this.state.paginated && this.state.value && this.state.idField){

                var values = this.state.value instanceof Array ? this.state.value : this.state.value.split(',');
                var ids = [];
                values.forEach(function(v){
                    ids.push(v);
                });
                if(ids.length){
                    urlParams[this.state.idField] = ids.join(',');
                    this._doInitialReload = true;
                    if(initialLimit){
                        delete urlParams.limit;
                    }

                }
            }
        }

        var doQuery = this._doInitialReload || !this.state.hasMinChars || (this.state.hasMinChars && query && query.length>=this.props.minChars);

        if(doQuery){
            $.ajax({
                url: this.props.url,
                data: urlParams,
                dataType: 'json',
                cache: false,
                success: function(data) {
                    var rawRecords = data[data.metaData.root];
                    var recordProperty = data.metaData.record;
                    var records = [];
                    rawRecords.forEach(function(v){
                        var rec = {};
                        if (recordProperty) {
                            rec = v[recordProperty];
                        } else {
                            rec = v;
                        }
                        
                        if(this.props.groupField && this.props.groupDisplayField){
                            rec._group = {
                                id:this.deepFind(v,this.props.groupField),
                                label:this.deepFind(v,this.props.groupDisplayField)
                            }
                        }
                        
                        if(!this.props.limitOptions || !this.props.limitOptions.length){
                            records.push(rec);
                        }else if(this.props.limitOptions.indexOf(rec[data.metaData.idField]) >= 0){
                            records.push(rec);
                        }
                    }.bind(this));
                    var nextState = {
                        records: records
                    };
                    if (data.metaData.idField) {
                        nextState.idField = data.metaData.idField;
                    }
                    if (data.metaData.displayField) {
                        nextState.displayField = data.metaData.displayField;
                    }

                    if(urlParams.limit){
                        var limit = urlParams.limit;
                        var total = data.total;
                        var page = this.state.page?this.state.page:1;
                        var hasPrevious = false;
                        var hasNext = false;
                        var totalPages = 0;
                        var currentPage = page;
                        if(total){
                            totalPages = Math.ceil(total/limit);
                            if(total>limit){
                                if(page>1){
                                    hasPrevious = true;
                                }

                                if(page<totalPages){
                                    hasNext = true;
                                }
                            }
                        }
                        nextState.hasPrevious = hasPrevious;
                        nextState.hasNext = hasNext;
                        nextState.totalPages = totalPages;
                        nextState.currentPage = currentPage;
                    }
                    
                    this.setState(nextState);
                    if(this._doInitialReload){
                        delete urlParams[this.state.idField];
                        if(initialLimit){
                            urlParams.limit = initialLimit;
                        }
                        this._doInitialReload = false;
                        if(!this.state.hasMinChars){
                            this.load();
                        }
                    }

                }.bind(this),
                error: function(xhr, status, err) {
                    alert(xhr.responseText);
                }
            })
        }else{
            this.setState({
                records:[]
            })
        }

    }

    getDisplay(rec){
        var state = this.state;
        if(this.props.getDisplayField){
            return this.props.getDisplayField(rec)
        }
        return rec[state.displayField];
    }

    render() {
        

        var items = [], searchField = '';
        var props = this.props;
        var state = this.state;
        var selectedItems = [];
        
        var pagingBar = undefined;

        if(state.hasNext || state.hasPrevious){
            pagingBar = <div className="paging-toolbar">
                <button className="previous-btn" onClick={this.onPrevious.bind(this)} disabled={!state.hasPrevious} >{__d('modules','Previous')}</button>
                <button className="next-btn" onClick={this.onNext.bind(this)} disabled={!state.hasNext}>{__d('modules','Next')}</button>
                <div className="page-info">{state.currentPage+'/'+state.totalPages}</div>
                <div className="clearfix"></div>
            </div>
        }
        
        var lastGroup = null;

        state.records.forEach(function(rec, i){
            if(state.paginated && state.selectedValues[rec[state.idField]]){
                state.selectedValues[rec[state.idField]] = rec[state.displayField];
            }else{
                if(this.props.groupField && rec._group){
                    var group = rec._group;
                    if(group.id!=lastGroup){
                        items.push(
                            <div key={'group'+group.id} className="search-results-group">
                                {group.label}
                            </div>
                        )
                        
                        lastGroup = group.id;
                    }
                }
                
                var isSelected = state.selectedValues[rec[state.idField]] ? true : false;
                
                items.push(
                    <div key={rec[state.idField]} className="search-result-row">
                        <label className="c-input c-checkbox">
                            <input type="checkbox" data-value={rec[state.idField]} data-label={rec[state.displayField]} checked={isSelected} onChange={this.onSelectionChange.bind(this)}/>
                            <span className="c-indicator"/>
                            <span className="c-label">{this.getDisplay(rec)}</span>
                        </label>
                    </div>
                )
            }
        }.bind(this));

        if(state.paginated){
            var values = Object.keys(state.selectedValues);
            if(values.length){
                var selectedItems = [];
                if(!props.selectedTop && items.length){
                    selectedItems.push(<div key="separator" className="divider" />);
                }
                values.forEach(function(value){
                    var label = state.selectedValues[value];
                    selectedItems.push(
                        <div key={value} className="search-result-row">
                            <label className="c-input c-checkbox">
                                <input type="checkbox" data-value={value} data-label={label} checked="true" onChange={this.onSelectionChange.bind(this)}/>
                                <span className="c-indicator"/>
                                <span className="c-label">{label}</span>
                            </label>
                        </div>
                    )
                }.bind(this));

                if(props.selectedTop && items.length){
                    selectedItems.push(<div key="separator" className="divider" />);
                }

                if(!props.selectedTop){
                    items = items.concat(selectedItems);
                }else{
                    items = selectedItems.concat(items);
                }
            }
        }

        if (props.url && state.showSearch) {
            searchField =
                <div className="field-holder input-search-holder">
                    <input type="text" placeholder="Search" value={this.state.query} onChange={this.onSearch.bind(this)} onKeyUp={this.onSearchKeyUp.bind(this)} ref="search_field" />
                    <i className="clear" onClick={this.clearSearch.bind(this)}/>
                </div>
            ;
        }

        var holderCls = 'btn-group custom-dropdown-wrapper multi-select-filter-wrapper';
        if(this.state.isActive){
            holderCls += ' active';
        }
        if(this.state.isExpanded){
            holderCls += ' expanded';
        }

        var buttons = null;
        if(this.props.applyFilters && this.props.clearFilters){
            buttons = (
                <div className="grid-filter-actions">
                    <a onClick={this.handleFilterButtons.bind(this)} data-button="apply" className="btn btn-primary apply-filter" role="button">{__d('modules','Apply')}</a>
                    <a onClick={this.handleFilterButtons.bind(this)} data-button="clear" className="btn btn-link clear-filter" role="button">{__d('modules','Reset')}</a>
                </div>
            );
        }

        var customDropdownButton = <div className="custom-dropdown-button">
            <button type="button" className="btn btn-primary dropdown-toggle custom-dropdown-toggle" ref="outside_click_trigger" onClick={this.togglePopup.bind(this)} data-toggle="custom-dropdown" aria-haspopup="true" aria-expanded="false">
                {props.label}
            </button>
        </div>;

        var customDropdownClearButton = <div className="custom-dropdown-clear-button">
            <button type="button" className="btn btn-primary clear-filter" onClick={this.clearFilter.bind(this)}><i/></button>
        </div>;

        if(props.hideButton){
            customDropdownButton = undefined;
            customDropdownClearButton = undefined;
        }

        setTimeout(() => {
            this.afterRender();
        }, 200);

        return (
            <div className={holderCls}>
                {customDropdownButton}
                {customDropdownClearButton}
                <div className={"card custom-dropdown-popup "+(state.paginated?" paginated":"") +(state.wide?" wide":"")} ref="outside_click_content">
                    <div className="card-block">
                        <div className="content">
                            {props.beforeContent}
                            {searchField}
                            <div className="results">
                                {items}
                            </div>
                            {pagingBar}
                            {buttons}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

ReactFilterCombo.propTypes = {
    label: PropTypes.string,
    idField: PropTypes.string,
    displayField: PropTypes.string,
    records: PropTypes.array,
    value: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.array
    ]),
    url: PropTypes.string,
    urlParams: PropTypes.object,
    singleSelect: PropTypes.bool,
    paginated: PropTypes.bool,
    wide: PropTypes.bool,
    showSearch: PropTypes.bool,
    applyFilters: PropTypes.func,
    clearFilters: PropTypes.func,
    loadGrid: PropTypes.func,
    minChars: PropTypes.any,
    limitOptions: PropTypes.array,
    beforeContent: PropTypes.object,
    selectedTop: PropTypes.bool,
    hideButton: PropTypes.bool,
};

ReactFilterCombo.defaultProps = {
    paginated: false,
    wide: false,
    showSearch: true,
    records: [],
    urlParams: {},
    value: '',
    minChars: 0,
    limitOptions: [],
    selectedTop: false
};